import KeyBoardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import LanguageIcon from '@mui/icons-material/Language'
import { Button, Menu, MenuItem, Typography } from '@mui/material'
import { MouseEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

type LanguageCode = 'de' | 'en' | 'es' | 'pl'

const lngs: Record<LanguageCode, { nativeName: string }> = {
  de: { nativeName: 'Deutsch' },
  en: { nativeName: 'English' },
  es: { nativeName: 'Español' },
  pl: { nativeName: 'Polski' },
}

const LanguageSelect = () => {
  const { i18n } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLanguageChange = (lng: string) => {
    i18n.changeLanguage(lng)
    handleClose()
  }

  return (
    <>
      <Button
        endIcon={<KeyBoardArrowDownIcon />}
        onClick={handleClick}
        startIcon={<LanguageIcon />}
        sx={{ alignItems: 'stretch' }}
      >
        <Typography variant="body2">{i18n.language}</Typography>
      </Button>
      <Menu anchorEl={anchorEl} onClose={handleClose} open={open}>
        {Object.keys(lngs).map((lng: string) => (
          <MenuItem key={lng} onClick={() => handleLanguageChange(lng)}>
            {lngs[lng as LanguageCode].nativeName}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
export default LanguageSelect
